import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "list-group-item" }
const _hoisted_2 = { class: "row align-items-center" }


export default /*@__PURE__*/_defineComponent({
  __name: 'BalancePaymentItem',
  props: {
    balance: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col" }, [
        _createElementVNode("h4", { class: "mb-0" }, " Saldo ")
      ], -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["col-auto", { 'text-muted': _ctx.balance == 0, 'fw-bold text-dark': _ctx.balance > 0 }])
      }, " R$ " + _toDisplayString(_ctx.balance.toFixed(2)), 3)
    ])
  ]))
}
}

})